module.exports = __webpack_public_path__ + "static/media/404.bc0db26e.png";